const questions = [
  {
    no: 1,
    type: "gridOptions",
    ques: "How good are you with following programming languages?",
    options: ["C", "C++", "Java", "Python"],
    radioOptions: [
      "Not familiar at all",
      "Beginner",
      "Decent",
      "Intermediate",
      "Very Good",
    ],
    desc: "\nBeginner - Can write basic programs given some time \nDecent - Can write basic programs within minutes, but struggle with lengthy programs \nIntermediate - Can write lengthy programs given some time \nVery Good - Can write lengthy programs within minutes",
  },
  {
    no: 2,
    type: "gridOptions",
    ques: "Roughly how many problems have you solved on the following Data Structures?",
    desc: "If confused between 2 options, go for the lower one",
    options: [
      "Array",
      "Queue",
      "Stack",
      "Linkedlist",
      "Heap",
      "Trees",
      "Graphs",
    ],
    radioOptions: ["0", "1-20", "21-50", "51-100", "100+"],
  },
  {
    no: 3,
    type: "gridOptions",
    ques: "Roughly how many problems have you solved of the following algorithms?",
    options: [
      "Greedy",
      "Recursion",
      "Searching/Sorting",
      "Math",
      "Dynamic Programming",
    ],
    desc: "If confused between 2 options, go for the lower one",
    radioOptions: ["0", "1-50", "51-100", "101-250", "250+"],
  },
  {
    no: 4,
    type: "radioOptions",
    ques: "Where do you stand on codechef?",
    options: [
      "Not started",
      "1 star",
      "2 stars",
      "3 stars",
      "4 stars",
      "5 stars",
      "6 stars",
      "7 stars",
    ],
    title: "cc_rating",
  },
  {
    no: 5,
    type: "gridOptions",
    ques: "How much would you rate yourself on Operating Systems?",
    options: [
      "Basics of Operating Systems",
      "Components of Operating Systems",
      "Process and Threads",
      "Deadlocks in Operating System",
      "Memory Management",
      "Segmentation and Disk Management",
    ],
    radioOptions: [
      "Not familiar at all",
      "Beginner",
      "Decent",
      "Intermediate",
      "Very Good",
    ],
    desc: "\nBeginner - Have very little (almost zero) understanding of the topic. \nDecent - Have some understanding of the topic, still not confident enough. \nIntermediate - Have a good understanding but not practised enough questions yet. \nVery Good - Have a deep understanding of the topic & can solve questions with ease.",
  },
  {
    no: 6,
    type: "gridOptions",
    ques: "How much would you rate yourself on Database Management Systems?",
    options: [
      "Introduction to DBMS & its architecture",
      "Keys and SQL",
      "Practical Problem Solving",
      "Different Types of Normalization",
      "Indexing and transaction management",
    ],
    radioOptions: [
      "Not familiar at all",
      "Beginner",
      "Decent",
      "Intermediate",
      "Very Good",
    ],
    desc: "\nBeginner - Have very little (almost zero) understanding of the topic. \nDecent - Have some understanding of the topic, still not confident enough. \nIntermediate - Have a good understanding but not practised enough questions yet. \nVery Good - Have a deep understanding of the topic & can solve questions with ease.",
  },
  {
    no: 7,
    type: "gridOptions",
    ques: "How much would you rate yourself on Computer Networks?",
    options: [
      "Introduction to Computer Networks",
      "Types of Layers & Network Topologies",
      "Introduction to Flow and Error Control",
      "Packets and Subnets",
      "Segmentation and Multiplexing",
      "Network Security",
    ],
    radioOptions: [
      "Not familiar at all",
      "Beginner",
      "Decent",
      "Intermediate",
      "Very Good",
    ],
    desc: "\nBeginner - Have very little (almost zero) understanding of the topic. \nDecent - Have some understanding of the topic, still not confident enough. \nIntermediate - Have a good understanding but not practised enough questions yet. \nVery Good - Have a deep understanding of the topic & can solve questions with ease.",
  },
  {
    no: 8,
    type: "gridOptions",
    ques: "Roughly how many problems have you solved on the following topic of Aptitude?",
    options: ["Verbal Ability", "Quantitative Aptitude", "Logical Reasoning"],
    radioOptions: ["0", "1-20", "21-50", "51-100", "100+"],
  },
  {
    no: 9,
    type: "radioOptions",
    ques: "How many strong projects do you have in your resume?",
    desc: "Count a project as a strong project only if you are thorough with each and every nuance about it & it is not a commonly available project picked from the internet.",
    options: ["0 strong projects", "1 strong project", "2+ strong projects"],
    title: "project",
  },
];

const colleges = [
  "A. C. Patil College of Engineering, Mumbai",
  "ABES Engineering College",
  "Aditya Engineering College",
  "Ajay Kumar Garg Engineering College, Ghaziabad",
  "Ajeenkya DY Patil University",
  "All India Shri Shivaji Memorial Societys - AISSMS",
  "Anil Neerukonda Institute of Technology and Sciences",
  "Asansol Engineering College (AEC)",
  "Atal Bihari Vajpayee IITM Gwalior",
  "BIT Sindri",
  "BMS College of Engineering",
  "Bapurao Deshmukh College of Engineering",
  "Bapurao Deshmukh College of Engineering, Sevagram",
  "Bhagwan Parshuram Institute of Technology",
  "Bharati Vidyapeeth College of Engineering",
  "Birla Institute of Technology, Mesra",
  "Birsa Institute of Technology, Sindri",
  "Central Institute of Technology, Kokrajhar",
  "Chandigarh University",
  "D Y Patil College Of Engineering",
  "Delhi Institute of Engineering & Technology",
  "Delhi Technological University",
  "Deogiri Institute of Engineering and Management Studies Aurangabad",
  "Dev Bhoomi Uttarakhand University",
  "G H Patel College of Engineering & Technology",
  "G H Raisoni College of Engineering",
  "G H Raisoni University, Amravati",
  "G H Raisoni University, Saikheda",
  "GANGA MEMORIAL COLLEGE OF POLYTECHNIC",
  "GLA University",
  "GMR Institute of Technology",
  "Galgotias College of Engineering & Technology",
  "Galgotias College of Engineering & Technology (GCET)",
  "Geethanjali College of Engineering and Technology",
  "Gharda Institute of Technology",
  "Global Engineering College, Jabalpur",
  "Global Institute of Information and Technology, Bangalore",
  "Global Nature Care Sangathan Group of Institutions",
  "Government College Of Engineering, Aurangabad",
  "Government College of Engineering, Amravati",
  "Government Engineering College, Nagpur",
  "Government Engineering College, Rajkot",
  "Graphic Era Hill University",
  "Guru Ghasidas Vishwavidyalaya",
  "Guru Gobind Singh Indraprastha University",
  "ICCS College of Engineering and Management, Kerala",
  "IIMT University, Meerut",
  "IK Gujral Punjab Technical University",
  "IMS Engineering College",
  "ISL Engineering College",
  "Indian Institute Of Technology – Bhilai (IIT–Bhilai)",
  "Indian Institute of Engineering Science and Technology, Shibpur",
  "Indian Institute of Information Technology (IIIT) Bhopal",
  "Indian Institute of Information Technology, Guwahati",
  "Indian Institute of Information Technology, Lucknow",
  "Indian Institute of Information Technology, Nagpur",
  "Indian Institute of Information Technology, Pune",
  "Indira Gandhi Institute Of Technology, Sarang",
  "Indore Institute of Science and Technology, Indore",
  "Institute of Aeronautical engineering, Hyd",
  "Institute of Engineering and Management",
  "Institute of Engineering and Management, Kolkata",
  "Institute of Engineering and Rural Technology, Prayagraj",
  "Institute of Technical Education and Research",
  "International Institute of Information Technology, Pune",
  "J D College of Engineering and Management",
  "J.K. Institute of Applied Physics and Technology",
  "Jalpaiguri Government Engineering College",
  "Jawaharlal Nehru University, New Delhi",
  "Jaypee Institute of Information Technology",
  "Jhulelal Institute of Technology",
  "K L Deemed To Be University",
  "K. J. Somaiya Institute of Engineering and Information Technology, Mumbai",
  "KDK College of Engineering, Nagpur",
  "Kalinga Institute Of Industrial Technology",
  "Krishna Institute of Engineering and Technology",
  "MIT Muzaffarpur",
  "Madan Mohan Malaviya University Of Technology",
  "Maharaja Agrasen Institute Of Technology",
  "Maharshi Dayanand University",
  "Malout Institute of Management and Information Technology",
  "Marathwada Mitra Mandal's Institute of Technology",
  "Medicaps University",
  "Mepco Schlenk Engineering College, Tamil Nadu",
  "Modern Education Society's College of Engineering",
  "Muzaffarpur Institute of Technology",
  "National Institute of Technology, Agartala",
  "National Institute of Technology, Karnataka Surathkal",
  "National Institute of Technology, Tiruchirappalli",
  "Netaji Subhas University of Technology",
  "Noida Institute of Engineering and Technology",
  "Pimpri Chinchwad College Of Engineering",
  "Pranveer Singh Institute Of Technology, Kanpur",
  "Pune Institute of Computer Technology",
  "Pune Vidhyarthi Griha's College of Engineering and Technology",
  "R. V. College of Engineering",
  "Raj Kumar Goel Institute Of Technology",
  "Rajiv Gandhi Proudyogiki Vishwavidyalaya",
  "Rajiv Gandhi University of Knowledge Technologies",
  "S. B. Jain Institute of Technology, Management and Research",
  "SKN Sinhgad Institute of Technology & Science, Lonavala",
  "SRM Institute of Science and Technology NCR",
  "Sandip institute of engineering and management",
  "Sant Longowal Institute of Engineering and Technology, Punjab",
  "Sharad Institute of Technology College of Engineering, Ichalkaranji (Kolhapur)",
  "Shir Ram Institute of Technology",
  "Shri Ramdeobaba College of Engineering and Management",
  "Sinhgad College of Engineering",
  "Smt. Kashibai Navale College Engineering",
  "Sri Venkateswara College of Engineering",
  "Tecnia Institute Of Advanced Studies",
  "Thadomal Shahani Engineering College",
  "Thapar Institute of Engineering & Technology",
  "The LNM Institute of Information Technology",
  "United College of Engineering and Research, Greater Noida",
  "Universal College of Engineering Mumbai",
  "University Institute of Engineering & Technology",
  "University of Hyderabad",
  "Vaagdevi College of Engineering",
  "Vallurupalli Nageswara Rao Vignana Jyothi Institute of Engineering & Technology",
  "Veermata Jijabai Technological Institute, Mumbai",
  "Vellore Institute of Technology - VIT Bhopal",
  "Vishwakarma Institute of Information Technology, Pune",
  "Vishwakarma Institute of Technology, Pune",
  "Yeshwantrao Chavan College of Engineering",
  "Zeal College of Engineering and Research, Pune",
];

export { questions, colleges };
